export default () => {
    const customArchiveProduct = document.querySelector('.customArchiveProduct');

    if(!customArchiveProduct) return;

    initializeArchiveOrderby();
    initializeArchiveFilters();
}

const initializeArchiveOrderby = () => {
    const orderByWrapper = document.querySelector('.customArchiveProduct__orderby');

    if(!orderByWrapper) return;

    orderByWrapper.addEventListener('click', () => {
        orderByWrapper.classList.toggle('active');
    })

    const options = orderByWrapper.querySelectorAll('.customArchiveProduct__orderby__option');
    const formSelect = orderByWrapper.querySelector('select[name="orderby"]');
    options.forEach(option => {
        option.addEventListener('click', () => {
            if(option.getAttribute('checked')) return;
            formSelect.value = option.getAttribute('data-value');
            formSelect.parentNode.submit();
        })
    })
}

const initializeArchiveFilters = () => {
    const opener = document.querySelector('.customArchiveProduct__filters__opener');
    const closer = document.querySelector('.customArchiveProduct__filters__dialog span.close');
    const dialog = document.querySelector('.customArchiveProduct__filters__dialog');
    if(!opener || !dialog || !closer) return;

    opener.addEventListener('click', () => {
        dialog.showModal();
    })

    closer.addEventListener('click', () => {
        dialog.close();
    })
}